var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;Object.defineProperty(exports,"engine",{enumerable:true,get:function get(){return _engine.default;}});Object.defineProperty(exports,"factor",{enumerable:true,get:function get(){return _factor.default;}});exports.getScaledValue=void 0;Object.defineProperty(exports,"isWebBased",{enumerable:true,get:function get(){return _isWebBased.default;}});Object.defineProperty(exports,"platform",{enumerable:true,get:function get(){return _platform.default;}});var _platform=_interopRequireDefault(require("./platform"));
var _factor=_interopRequireDefault(require("./factor"));
var _engine=_interopRequireDefault(require("./engine"));
var _is=require("../is");








var _isWebBased=_interopRequireDefault(require("./isWebBased"));



var getScaledValue=function getScaledValue(v){
if(_is.isPlatformTizenmobile)return v*3;
if(_is.isPlatformTizenwatch)return v*2;
if(_is.isPlatformTvos)return v*2;
if(_is.isPlatformTizen)return v*2;
if(_is.isPlatformWebos)return v*2;
if(_is.isPlatformXbox)return v*1.5;
return v;
};exports.getScaledValue=getScaledValue;var _default=

{
platform:_platform.default,
formFactor:_factor.default,
factor:_factor.default,
engine:_engine.default,
isWebBased:_isWebBased.default};exports.default=_default;
//# sourceMappingURL=index.js.map